/**
 * Application Insights custom event names. Names describe what the user did, not which screen they were on,
 * so they stay stable when screens change. Events carry only the properties allowed by `TelemetryService.trackAppEvent`.
 */
export enum TelemetryEvent {
  CaseViewed = 'surface_io.case.viewed',
  CaseListFiltered = 'surface_io.case.list_filtered',
  CaseClaim = 'surface_io.case.claim',
  CaseDecisionSubmitted = 'surface_io.case.decision_submitted',
  CaseReturned = 'surface_io.case.returned',
  CaseCommentAdded = 'surface_io.case.comment_added',
  CaseFeedbackSubmitted = 'surface_io.case.feedback_submitted',
  CaseLateAttachResolved = 'surface_io.case.late_attach_resolved',
  CaseNetworkViewed = 'surface_io.case.network_viewed',
  CaseStepFormLoaded = 'surface_io.case.step_form_loaded',
  CaseCommandFailed = 'surface_io.case.command_failed',
  CaseDossierLoadFailed = 'surface_io.case.dossier_load_failed',
  CaseLoadFailed = 'surface_io.case.load_failed',
  CaseStepReleased = 'surface_io.case.step_released',
  AgentRunRerunRequested = 'surface_io.agent_run.rerun_requested',
}
